import React from 'react'
import Helmet from 'react-helmet'
import {
  Layout,
  BannerSmall,
  CallUs,
  ContactForm,
  ContactData,
  BannerLinks,
  TextBox,
  PopUp
} from '../components'

import contacts from '../components/CallUs/DefaultContacts'

import BannerImage from '../assets/header.kontakt.jpg'
import JoinTheTeam from '../assets/bannerlinks/jointheteam.jpg'
import TakeOff from '../assets/bannerlinks/takeoff.jpg'

const boxes = [
  {
    text: 'Datenschutz',
    image: JoinTheTeam,
    link: '/datenschutzerklaerung',
    linkText: 'Mehr lesen'
  },
  {
    text: 'Das erwartet Dich:',
    image: TakeOff,
    link: '/technologie',
    linkText: 'Mehr lesen'
  }
]

const Karriere = () => (
  <Layout>
    {/*

-------------------------------------------------------------------------

     Only uncomment when null job offers have status = 'now' 

-------------------------------------------------------------------------
    
    */}
    {/* <PopUp
      title="Initiative erwünscht!"
      description="Wir schätzen Initiativbewerbungen und freuen uns darauf, von talentierten und motivierten Menschen zu hören."
      linkText="Initiativbewerbung"
    /> */}
    <Helmet
      title="Karriere @holzweg"
      meta={[
        {
          name: 'description',
          content:
            'Wir legen Wert auf motivierte Kollegen, eigene Ideen und Kreativität. Damit deine Freizeit nicht zu kurz kommt, bieten wir flexible Arbeitszeiten. Willst du in einem netten Team, einer familiären Atmosphäre arbeiten?'
        },
        {
          name: 'keywords',
          content:
            'Karriere holzweg, Webagentur holzweg, Karriere, Job, Jobs Tirol, Jobs Innsbruck, Jobs Programmierer Tirol'
        },
        {
          property: 'og:description',
          content:
            'Wir legen Wert auf motivierte Kollegen, eigene Ideen und Kreativität. Damit deine Freizeit nicht zu kurz kommt, bieten wir flexible Arbeitszeiten. Willst du in einem netten Team, einer familiären Atmosphäre arbeiten?'
        },
        {
          property: 'og:image',
          content:
            'https://www.holzweg.com/static/header.kontakt-22a365b8b71ce5d94cf1f1f6e26bc535.jpg'
        }
      ]}
    >
      <script type="application/ld+json">
        {`
        [
          {
            "@context": "https://schema.org/",
            "@type": "JobPosting",
            "title": "Sekreteriat (Teilzeit)",
            "description": " Bei holzweg entwickeln wir maßgeschneiderte Online-Auftritte und Softwarelösungen für unsere B2B-Kunden. Aktuell suchen wir eine engagierte und gut organisierte Unterstützung für unser Team, die sowohl unsere Finanzprozesse verwalten als auch die Ordnung und das Wohlbefinden im Büro sicherstellen kann.",
            "identifier": {
              "@type": "PropertyValue",
              "name": "Holzweg Webagentur",
              "value": "1234567"
            },
            "datePosted": "2024-07-02",
            "validThrough": "2024-09-01",
            "employmentType": "PART_TIME",
            "hiringOrganization": {
              "@type": "Organization",
              "name": "holzweg GmbH",
              "sameAs": "https://www.holzweg.com",
              "logo": "https://www.holzweg.com/icons/icon-512x512.png?v=69a8636a704d0d6c27617de81dc08cca"
            },
            "jobLocation": {
              "@type": "Place",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Adamgasse 11",
                "addressLocality": "Innsbruck",
                "addressRegion": "Tyrol",
                "postalCode": "6020",
                "addressCountry": "AT"
              }
            },
            "baseSalary": {
              "@type": "MonetaryAmount",
              "currency": "EUR",
              "value": {
                "@type": "QuantitativeValue",
                "value": 20.00,
                "unitText": "HOUR"
              }
            }
          }
        ]
        `}
      </script>
      <script type="application/ld+json">
        {`
        [
          {
            "@context": "https://schema.org/",
            "@type": "JobPosting",
            "title": "Projektmanager:in & UI-/UX-Designer:in",
            "description": "Du liebst es, unsere Kund:innen zu begeistern und Webdesigns zu entwickeln? Dann bist du bei uns genau richtig! Wir sind eine renommierte Webagentur mit Sitz in Innsbruck und arbeiten im B2B Bereich mit bekannten Unternehmen an ihren Online-Auftritten und Softwarelösungen.\nDeine Aufgaben\n- Du sorgst für die reibungslose und wirtschaftliche Abwicklung von Webprojekten\n- Du nimmst Anfragen entgegen, fragst nach, empfiehlst Lösungen und verteilst Aufgaben auf das Team\n- Du leitest Workshops und Brainstorming Meetings gemeinsam mit unseren Kund:innen\n- Du analysierst bestehende Systeme und empfiehlst Verbesserungen im Hinblick auf aktuelle Trends\n- Du bist die Schnittstelle zwischen Entwicklung und unseren Kunden\n- Du erstellst selbstständig Webdesigns, die von einer gesamten Website bis hin zu einem einzelnen Widget reichen\n- Du erstellst maßgeschneiderte Angebote\nMust-have Skills\n- Organisationstalent\n- Du hast ein Gespür für das Design von Websites\n- Du bist interessiert an neuen Web-Trends\n- Du verstehst, wie ein CMS funktioniert und kannst (nach einer kurzen Einschulung) eigenständig Bearbeitungen durchführen\n- Du hast eine rasche Auffassungsgabe, bist redegewandt und hast ein sicheres Auftreten\n- Selbstständigkeit, Teamgeist, hohe Lernbereitschaft und proaktives, lösungsorientiertes Denken gehören zu deinen Stärken\nNice-to-have\n- Erfahrung mit der Erstellung von Webdesigns\n- SEO-Kenntnisse\nWas wir dir bieten:\n- Unbefristete Festanstellung für ca. 20h/Woche\n- Flexible Arbeitszeiten und Möglichkeit zum Home-Office\n- Schönes Büro in zentraler Lage und freien Kaffee\n- IT-Zeitschrift-Abo\n- Ein hilfsbereites, fachlich exzellentes und sympathisches Team\n- Angenehmes und kollegiales Betriebsklima mit verschiedenen Social Events (Stammtische, Table Soccer WM...) und gemeinsamen Mittagessen\n- Zertifizierungs- und Fortbildungsmöglichkeiten\nFür diese Position gilt ein Mindestgrundgehalt laut aktuellstem Kollektivvertrag mit Bereitschaft zur Überzahlung je nach Qualifikation und Berufserfahrung. Solltest du Interesse haben, freuen wir uns darauf, dich persönlich kennen zu lernen! Schick doch einfach eine E-Mail an bewerbung@holzweg.com",
            "identifier": {
              "@type": "PropertyValue",
              "name": "Holzweg Webagentur",
              "value": "1234567"
            },
            "datePosted": "2024-02-26",
            "validThrough": "2024-03-26",
            "employmentType": "PART_TIME",
            "hiringOrganization": {
              "@type": "Organization",
              "name": "holzweg GmbH",
              "sameAs": "https://www.holzweg.com",
              "logo": "https://www.holzweg.com/icons/icon-512x512.png?v=69a8636a704d0d6c27617de81dc08cca"
            },
            "jobLocation": {
              "@type": "Place",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Adamgasse 11",
                "addressLocality": "Innsbruck",
                "addressRegion": "Tyrol",
                "postalCode": "6020",
                "addressCountry": "AT"
              }
            },
            "baseSalary": {
              "@type": "MonetaryAmount",
              "currency": "EUR",
              "value": {
                "@type": "QuantitativeValue",
                "value": 20.00,
                "unitText": "HOUR"
              }
            }
          }
        ]
        `}
      </script>
    </Helmet>
    <BannerSmall image={BannerImage} title="Der Weg zum Erfolg" />
    <TextBox
      title="Wo Sicherheit auf Herzlichkeit trifft"
      text={
        <>
          <p>
            Bei holzweg legen wir nicht nur Wert auf die fachlichen
            Qualifikationen unserer Mitarbeiter:innen, sondern auch auf den
            persönlichen Umgang miteinander. Wir glauben, dass ein positives
            Arbeitsklima und ein freundlicher Umgangston sich positiv auf die
            Arbeitsergebnisse auswirken. Aus diesem Grund bieten wir unseren
            Mitarbeiter:innen ein familiäres Umfeld, in dem alle Mitarbeitenden
            individuelle Stärken einbringen und gemeinsam an Projekten arbeiten
            können. Dies spiegelt sich auch in unseren Kundenbeziehungen wider,
            denn ein freundliches und empathisches Team kommt bei Kund:innen
            sehr gut an.
          </p>

          <p>
            Als wachsendes Unternehmen sind wir ständig auf der Suche nach
            motivierten Talenten aus den Bereichen Software Development,
            Webdevelopment, Frontend Development und Lehrlinge. Wir bieten
            unseren Mitarbeiter:innen interessante Projekte und vielfältige
            Aufgaben, um ihr Potential voll auszuschöpfen und sich fachlich
            weiterzuentwickeln. Unser Ziel ist es, gemeinsam mit unseren
            Mitarbeiter:innen erfolgreich zu sein und uns gemeinsam
            weiterzuentwickeln. Wenn du auf der Suche nach einem Arbeitsplatz
            bist, der Sicherheit und Herzlichkeit verbindet, bist du bei holzweg
            genau richtig.
          </p>
        </>
      }
    />
    <TextBox
      isMulticolorHead={true}
      title="Bewirb dich als:"
      buttons={[
        {
          link: '#projektmanagement',
          text: 'Projektmanager:in & UI-/ UX-Designer:in',
          color: 'orange'
        },
        {
          link: '#sekretariat',
          text: 'Sekretariat (Teilzeit)',
          color: 'orange'
        },
        { link: '#scrummaster', text: 'Scrum Master', color: 'orange' },
        { link: '#webdev', text: 'Web-DeveloperIn', color: 'orange' },
        { link: '#developer', text: 'Frontend DeveloperIn', color: 'orange' },
        {
          link: '#jsDeveloper',
          text: 'Fullstack JS DeveloperIn',
          color: 'orange'
        },
        { link: '#lehrling', text: 'Lehrling', color: 'orange' }
      ]}
    />
    <TextBox
      id="projektmanagement"
      title={
        <>
          Projektmanager:in &<br /> UI-/ UX-Designer:in
        </>
      }
      isMulticolor={true}
      status="now"
      text={
        <span>
          <p>
            Du liebst es, unsere Kund:innen zu begeistern und Webdesigns zu
            entwickeln? Dann bist du bei uns genau richtig! Wir sind eine
            renommierte Webagentur mit Sitz in Innsbruck und arbeiten im B2B
            Bereich mit bekannten Unternehmen an ihren Online-Auftritten und
            Softwarelösungen.
          </p>
          <h3>Deine Aufgaben</h3>
          <ul>
            <li>
              Du sorgst für die reibungslose und wirtschaftliche Abwicklung von
              Webprojekten
            </li>
            <li>
              Du nimmst Anfragen entgegen, fragst nach, empfiehlst Lösungen und
              verteilst Aufgaben auf das Team
            </li>
            <li>
              Du leitest Workshops und Brainstorming Meetings gemeinsam mit
              unseren Kund:innen
            </li>
            <li>
              Du analysiert bestehende Systeme und empfiehlst Verbesserungen im
              Hinblick auf aktuelle Trends
            </li>
            <li>
              Du bist die Schnittstelle zwischen Entwicklung, unseren Kunden
            </li>
            <li>
              Du erstellst selbstständig Webdesigns, die von einer gesamten
              Website bis hin zu einem einzelnen Widget reichen
            </li>
            <li>Du erstellst maßgeschneiderte Angebote</li>
          </ul>
          <h3>Must have Skills</h3>
          <ul>
            <li>Organisationstalent</li>
            <li>Du hast ein Gespür für das Design von Websites</li>
            <li>Du bist interessiert an neuen Web-Trends</li>
            <li>
              Du verstehst, wie ein CMS funktioniert und kannst (nach einer
              kurzen Einschulung) eigenständig Bearbeitungen durchführen
            </li>
            <li>
              Du hast eine rasche Auffassungsgabe, bist redegewandt und hast ein
              sicheres Auftreten
            </li>
            <li>
              Selbstständigkeit, Teamgeist, hohe Lernbereitschaft und
              proaktives, lösungsorientiertes Denken gehören zu deinen Stärken
            </li>
          </ul>
          <h3>Nice to have</h3>
          <ul>
            <li>Erfahrung mit der Erstellung Webdesigns</li>
            <li>SEO-Kenntnisse</li>
          </ul>
          <h3>Was wir dir bieten:</h3>
          <ul>
            <li>Unbefristete Festanstellung für ca. 20h/Woche</li>
            <li>Flexible Arbeitszeiten und Möglichkeit zum Home-Office</li>
            <li>Schönes Büro in zentraler Lage und freien Kaffee</li>
            <li>IT-Zeitschrift-Abo</li>
            <li>
              Ein hilfsbereites, fachlich exzellentes und sympathisches Team
            </li>
            <li>
              Angenehmes und kollegiales Betriebsklima mit verschiedenen Social
              Events (Stammtische, Table Soccer WM...) und gemeinsamen
              Mittagessen
            </li>
            <li>Zertifizierungs- und Fortbildungsmöglichkeiten</li>
          </ul>
          <br />
          <p>
            Für diese Position gilt ein Mindestgrundgehalt laut aktuellstem
            Kollektivvertrag mit Bereitschaft zur Überzahlung je nach
            Qualifikation und Berufserfahrung. Solltest du Interesse haben,
            freuen wir uns darauf, dich persönlich kennen zu lernen! Schick doch
            einfach eine Email an{' '}
            <a href="mailto:bewerbung@holzweg.com">bewerbung@holzweg.com</a>
          </p>
        </span>
      }
    />
    <TextBox
      id="sekretariat"
      title={<>Sekretariat (Teilzeit)</>}
      isMulticolor={true}
      status="now"
      text={
        <span>
          <p>
            Bei holzweg entwickeln wir maßgeschneiderte Online-Auftritte und
            Softwarelösungen für unsere B2B-Kunden. Aktuell suchen wir eine
            engagierte und gut organisierte Unterstützung für unser Team, die
            sowohl unsere Finanzprozesse verwalten als auch die Ordnung und das
            Wohlbefinden im Büro sicherstellen kann.
          </p>
          <h3>Deine Aufgaben</h3>
          <ul>
            <li>
              Finanzverwaltung: Erfassung von Eingangsrechnungen und Erstellung
              von Ausgangsrechnungen.
            </li>
            <li>Bankgeschäfte: Anlegen und Verwalten von Überweisungen.</li>
            <li>
              Zeiterfassung: Verwaltung von Urlaubs- und Gleitzeitkonten der
              Mitarbeiter.
            </li>
            <li>
              Administrative Unterstützung: Vorbereitung der Unterlagen für die
              Buchhaltung, Dokumentenablage und -management.{' '}
            </li>
            <li>
              Assistenz der PM/GF: Unterstützung bei täglichen Aufgaben,
              Durchführung einfacher Tests und Qualitätskontrollen.
            </li>
            <li>
              Büroorganisation: Pflege der Büropflanzen und Aufrechterhaltung
              der Ordnung und Sauberkeit im Büro.
            </li>
          </ul>
          <h3>Was du mitbringen solltest:</h3>
          <ul>
            <li>
              Abgeschlossene kaufmännische Ausbildung oder Erfahrung in
              ähnlichen Bereichen.
            </li>
            <li>Sicherer Umgang mit Google Sheets und anderen Office-Tools.</li>
            <li>
              Hohes Maß an Zuverlässigkeit und eine selbstständige Arbeitsweise.
            </li>
            <li>
              Gute organisatorische Fähigkeiten und ein freundliches Auftreten.
            </li>
            <li>Teamfähigkeit und ein hohes Maß an Diskretion.</li>
          </ul>
          <h3>Was wir dir bieten:</h3>
          <ul>
            <li>
              Unbefristete Teilzeitanstellung für ca. 20 Stunden pro Woche.
            </li>
            <li>
              Flexible Arbeitszeiten, ideal für Eltern, die ihre Arbeit um die
              Schulzeiten ihrer Kinder herum planen möchten: Vier Vormittage im
              Büro, der Rest im Home-Office.
            </li>
            <li>
              Modernes Büro in zentraler Lage mit kostenlosem Kaffee und
              weiteren Annehmlichkeiten.
            </li>
            <li>Ein professionelles, unterstützendes und freundliches Team.</li>
            <li>
              Regelmäßige Team-Events und gemeinsame Aktivitäten für ein
              kollegiales Betriebsklima.{' '}
            </li>
            <li>Zugang zu Fortbildungen und Zertifizierungsmöglichkeiten.</li>
            <li>
              Zertifizierungs- und FortbildungsmöglichkeitenGehalt: Entsprechend
              dem Kollektivvertrag (AT/Regelstufe 2.968€ für 38,5h/Woche), mit
              der Bereitschaft zur Überzahlung abhängig von Qualifikation und
              Erfahrung.
            </li>
          </ul>
          <h3>Interessiert?</h3>
          <p>
            Wir freuen uns darauf, dich kennenzulernen! Bitte sende deine
            Bewerbungsunterlagen per E-Mail an{' '}
            <a href="mailto:jobs@holzweg.com">jobs@holzweg.com</a>. Wir sind
            gespannt, wie du unser Team mit deinen Fähigkeiten und deiner
            Persönlichkeit bereichern kannst. Diskutiere mit uns deine genauen
            Arbeitszeiten - wir sind flexibel und gehen auf deine Bedürfnisse
            ein, um eine Win-Win-Situation für beide Seiten zu schaffen!
          </p>
        </span>
      }
    />
    <TextBox
      id="scrummaster"
      title="Scrum Master"
      isMulticolor={true}
      status="initiative"
      text={
        <span>
          <p>
            Für ein agiles Projekt mit einem langjährigen Kunden suchen wir ab
            sofort einen Scrum Master (m/f/d) ab 20h/W.
          </p>
          <p>
            Wenn Dir Menschen, ein kleines Team und Kommunikation auf Augenhöhe
            wichtig sind und Dein Herz für Webapplikationen, deren Konzeption,
            Entwicklung und kontinuierliche Verbesserung schlägt, dann freuen
            wir uns auf Deine Bewerbung!
          </p>
          <h3>Was machst Du als Scrum Master bei uns?</h3>
          <ul>
            <li>
              Du begleitest ein junges motiviertes Scrum-Team mit 2-5 Full-Stack
              Developern durch zweiwöchige Sprints
            </li>
            <li>
              Du hilfst dem Team dabei das Sprintziel im Fokus zu behalten und
              mögliche Schwierigkeiten aus dem Weg zu räumen
            </li>
            <li>
              Du moderierst Scrum-Meetings wie Daily Standup, Sprint Refinement,
              Planning, Review und protokollierst Entscheidungen
            </li>
            <li>
              Du bist erste Ansprechperson für den Product Owner (Kund:innen)
              und hilfst dabei Wünsche als schätzbare Userstories zu formulieren
              und Bugs strukturiert zu erfassen und zu lösen
            </li>
            <li>Du kontrollierst die Zielerreichung umgesetzter Userstories</li>
          </ul>
          <br />

          <h3>Anforderungen für den Job bei holzweg:</h3>
          <ul>
            <li>Du bist mit der agilen Arbeitsweise vertraut</li>
            <li>Du bist offen gegenüber Neuem und alternativen Lösungswegen</li>
            <li>
              Du bist kommunikativ und kannst andere überzeugen und begeistern
            </li>
            <li>
              Du kannst dich selbst und andere führen und scheust dich nicht vor
              Widerstand
            </li>
            <li>Du entwickelst gerne im Team Lösungen</li>
            <li>Du hast ein gutes Gefühl für Menschen und Teamdynamik</li>
          </ul>
          <br />

          <h3>Was wir dir bieten:</h3>
          <ul>
            <li>Unbefristete Festanstellung</li>
            <li>Flexible Arbeitszeiten und Möglichkeit zum Home-Office</li>
            <li>
              Schönes Büro in zentraler Lage in Innsbruck (2 Gehminuten zum
              Bahnhof)
            </li>
            <li>
              Ein hilfsbereites, fachlich exzellentes und sympathisches Team
            </li>
            <li>
              Angenehmes und kollegiales Betriebsklima mit verschiedenen Social
              Events (Stammtische, Table Soccer WM...), gemeinsamen Mittagessen
              und freiem Kaffee
            </li>
            <li>Zertifizierungs- und Fortbildungsmöglichkeiten</li>
          </ul>
          <br />
          <p>
            Für diese Position gilt ein Mindestgrundgehalt laut aktuellstem
            Kollektivvertrag mit Bereitschaft zur Überzahlung je nach
            Qualifikation und Berufserfahrung!
            <br />
            Solltest du Interesse haben, freuen wir uns darauf, dich persönlich
            kennen zu lernen! Schick doch einfach eine Email an{' '}
            <a href="mailto:bewerbung@holzweg.com">bewerbung@holzweg.com</a>
          </p>
        </span>
      }
    />
    <TextBox
      id="webdev"
      title="Web-DeveloperIn"
      isMulticolor={true}
      status="initiative"
      text={
        <span>
          <p>
            Als Innsbrucker Full-Service Webagentur beraten und betreuen wir
            international namhafte Kund:innen von der Planung bis zur Umsetzung
            von IT-Projekten! Wenn du auf der Suche nach nach einer neuen
            Herausforderung ab 20h/Woche bist, dann bist du bei uns genau
            richtig!
          </p>
          <h3>Deine Skills:</h3>
          <ul>
            <li>Du willst Spass in einem jungen und motivierten Team haben?</li>
            <li>Du hast Humor und etwas im Köpfchen?</li>
            <li>Du hast Web-Development Erfahrung?</li>
            <li>Du hast Erfahrung mit Typo3?</li>
            <li>Du arbeitest verantwortungsbewusst und eigenständig?</li>
            <li>Du interessierst dich für Zukunftstrends?</li>
          </ul>
          <br />

          <p>Ja? Dann bist du bei uns genau richtig!</p>

          <h3>Was wir dir bieten:</h3>
          <ul>
            <li>Unbefristete Festanstellung in Teilzeit (20h/Woche)</li>
            <li>Flexible Arbeitszeiten und Möglichkeit zum Home-Office</li>
            <li>Schönes Büro in zentraler Lage und freien Kaffee</li>
            <li>IT-Zeitschrift-Abo</li>
            <li>
              Ein hilfsbereites, fachlich exzellentes und sympathisches Team
            </li>
            <li>
              Angenehmes und kollegiales Betriebsklima mit verschiedenen Social
              Events (Stammtische, Table Soccer WM...) und gemeinsamen
              Mittagessen
            </li>
            <li>Zertifizierungs- und Fortbildungsmöglichkeiten</li>
          </ul>
          <br />
          <p>
            Für diese Position gilt ein Mindestgrundgehalt laut aktuellstem
            Kollektivvertrag mit Bereitschaft zur Überzahlung je nach
            Qualifikation und Berufserfahrung!
            <br />
            Solltest du Interesse haben, freuen wir uns darauf, dich persönlich
            kennen zu lernen! Schick doch einfach eine Email an{' '}
            <a href="mailto:bewerbung@holzweg.com">bewerbung@holzweg.com</a>
          </p>
        </span>
      }
    />
    <TextBox
      id="developer"
      title="Frontend DeveloperIn"
      isMulticolor={true}
      status="initiative"
      text={
        <span>
          <p>
            Zu deinen Aufgaben gehören unter anderem die Entwicklung moderner
            User Interfaces mit Blick auf Browser Support und Performance sowie
            die Pflege, Wartung und Dokumentation von Anwendungen und Prozessen.
          </p>
          <h3>Must have Skills</h3>
          <ul>
            <li>Ausgeprägte HTML/CSS-Kenntnisse</li>
            <li>Du hast eine rasche Auffassungsgabe</li>
            <li>
              Selbstständigkeit, Teamgeist, hohe Lernbereitschaft und proaktives
              lösungsorientiertes Denken gehören zu deinen Eigenschaften.
            </li>
          </ul>
          <h3>Nice to have</h3>
          <ul>
            <li>
              Erfahrung in JavaScript und JavaScript Frameworks (wie React oder
              Vue.js).
            </li>
            <li>CMS-Kenntnisse (Wordpress, Typo3, eZ platform)</li>
            <li>Kenntnisse in SCSS/SASS sind von Vorteil.</li>
          </ul>
          <h3>Was wir dir bieten:</h3>
          <ul>
            <li>Unbefristete Fixanstellung in Vollzeit oder Teilzeit</li>
            <li>Flexible Arbeitszeiten und Möglichkeit zum Home-Office</li>
            <li>Schönes Büro in zentraler Lage und freien Kaffee</li>
            <li>
              Angenehmes und kollegiales Betriebsklima mit verschiedenen Social
              Events (Stammtische, Table Soccer WM...)
            </li>
            <li>Zertifizierungs- und Fortbildungsmöglichkeiten</li>
          </ul>
          <br />
          <p>
            Für diese Position gilt ein Mindestgrundgehalt laut aktuellstem
            Kollektivvertrag mit Bereitschaft zur Überzahlung je nach
            Qualifikation und Berufserfahrung!
            <br />
            Solltest du Interesse haben, freuen wir uns darauf, dich persönlich
            kennen zu
            <br />
            lernen! Schick doch einfach eine Email an{' '}
            <a href="mailto:bewerbung@holzweg.com">bewerbung@holzweg.com</a>!
          </p>
        </span>
      }
    />
    <TextBox
      id="jsDeveloper"
      title="FullStack JS DeveloperIn gesucht!"
      isMulticolor={true}
      status="initiative"
      text={
        <span>
          <p>
            Wir suchen hochqualifizierte und motivierte Entwickler:innen. Deine
            Aufgabe wird es sein im agilen Ansatz mit Hilfe von React, Prisma,
            TypeScript und GraphQL Applikationen zu entwickeln.
          </p>
          <p>
            <b>
              Du bist FullStack JS Developer, hast idealerweise Erfahrung mit
              React und agiler Methodik?
            </b>
          </p>
          <p>
            Wir bieten flexible Arbeitszeiten, nettes Team in familiärer
            Atmosphäre, tägliche Tischfussballturniere und gemeinsames
            Mittagessen!
          </p>
          <p>
            Monatseinkommen ab € 3.000.- brutto für Vollzeit mit Bereitschaft
            zur Überzahlung abhängig von Erfahrung und Ausbildung.
          </p>
          <p>Worauf wartest Du noch? Legen wir los:</p>
          <p>
            <b>Unterlagen per E-Mail bitte an:</b>
            <br />
            <a href="mailto:bewerbung@holzweg.com">bewerbung@holzweg.com</a>
          </p>
        </span>
      }
    />
    <TextBox
      id="lehrling"
      title="Lehrling gesucht!"
      isMulticolor={true}
      status="initiative"
      text={
        <span>
          <p>
            Wir suchen nach zukünftigen IT-Heldinnen und Helden.
            <br />
            Nutze die Chance in einem innovativen Tiroler IT Unternehmen eine
            Lehre zum <b>„ApplikationsentwicklerIn - Coding“</b> (Berufsbereich
            Informationstechnologie) zu starten!
          </p>
          <p>
            <b>
              Wir bieten ein spannendes Arbeitsumfeld mit einer
              praxisorientierten Berufsausbildung und tollen
              Entwicklungsmöglichkeiten!
            </b>
          </p>
          <ul>
            <li>
              <span>Du hast einen positiven Pflichtschulabschluss</span>
            </li>
            <li>
              <span>Du besitzt Basiskenntnisse in HTML</span>
            </li>
            <li>
              <span>Du bist aufgeschlossen und engagiert</span>
            </li>
          </ul>
          <p>
            Wir bieten dir ein tolles Arbeitsklima und du hast bei uns eine sehr
            praxisorientierte Berufsausbildung und kannst neben der Lehre auch
            die Matura machen!
          </p>
          <p>
            Lehrlingsentschädigung laut IT-Kollektivvertrag <br />
            Wir freuen uns auf aussagekräftige Bewerbungen, gerne mit
            Vorstellungswebsite, von motivierten jungen Menschen an{' '}
            <a href="mailto:bewerbung@holzweg.com">bewerbung@holzweg.com</a>!
          </p>
        </span>
      }
    />
    <CallUs contacts={contacts} title="Wir beißen nicht:" />
    <BannerLinks boxes={boxes} />
  </Layout>
)

/**
 * <p>Wir legen Wert auf motivierte Kollegen, eigene Ideen und Kreativität. Damit deine Freizeit nicht zu kurz kommt, bieten wir flexible Arbeitszeiten. Willst du in einem netten Team, einer familiären Atmosphäre arbeiten? Dann schick deine Unterlagen an <a href="mailto:bewerbung@holzweg.com?subject=Bewerbung%20bei%20holzweg">bewerbung@holzweg.com</a></p><p><b>Unterlagen per Post bitte an:</b><br /> holzweg GmbH<br /> z.H. Mag. Melanie Lenz-Kumnig<br /> Adamgasse 11, 3. Stock<br />6020 Innsbruck</p>
 **/

export default Karriere
